module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/patients/results-review.component.css
// module id = ./src/app/views/patients/results-review.component.css
// module chunks = main